export default __webpack_public_path__ + "e73934ba8a14debb0ce65f1bb37f402f.png";